import { IsNotEmpty } from 'main/common/validation/decorators/IsNotEmpty'
import { FormModel } from 'main/common/form-state-manager/FormModel'

export class OpportunitySourceFormModel extends FormModel {

    @IsNotEmpty()
    name: string

    isActive: boolean
    hasDetail: boolean

    constructor(initialData?: any) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
